var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.329 4.35532C10.9993 4.19842 11.6856 4.11999 12.374 4.12161C19.1907 4.12161 23.0859 11.9121 23.0859 11.9121C22.4948 13.0179 21.7898 14.0591 20.9825 15.0185M14.4385 13.9765C14.171 14.2636 13.8485 14.4938 13.4901 14.6535C13.1318 14.8131 12.7449 14.899 12.3527 14.9059C11.9604 14.9128 11.5708 14.8407 11.207 14.6937C10.8432 14.5468 10.5128 14.3281 10.2354 14.0507C9.95795 13.7733 9.73926 13.4428 9.59233 13.0791C9.44539 12.7153 9.37324 12.3257 9.38016 11.9334C9.38708 11.5411 9.47294 11.1543 9.63261 10.7959C9.79228 10.4376 10.0225 10.1151 10.3095 9.8476M18.1584 17.6965C16.4938 18.9654 14.4668 19.6683 12.374 19.7025C5.55734 19.7025 1.66211 11.9121 1.66211 11.9121C2.87342 9.65468 4.55348 7.68244 6.58958 6.12765L18.1584 17.6965Z",
    stroke: "black",
    strokeWidth: 1.75286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66211 1.2002L23.0859 22.624",
    stroke: "black",
    strokeWidth: 1.75286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3714,
    height: 23.3714,
    fill: "white",
    transform: "translate(0.688477 0.226074)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEye);
export default __webpack_public_path__ + "static/media/password_eye.f3ec6d8954ae918ef5acf5625c9c2aa8.svg";
export { ForwardRef as ReactComponent };